// deps
import React, { ReactElement, memo, useMemo } from "react";

// internal deps
import { isEmpty } from "@swiggy-private/payment-core";

// components
import PaymentGroupTitle from "../components/Title";
import PaymentGroupContainer from "../components/Container";
import BillToCompanyPaymentMethod from "@payment-ui/components/payment-method/bill-to-company";

// helpers
import {
    getPaymentMethods,
    isPaymentMethodSelected,
    generatePaymentMethodId,
    getPaymentGroupDisplayName,
    isPaymentGroupEnabled,
    getPaymentGroupDisableMessage,
    getPaymentGroupIconUrl,
} from "@payment-ui/helpers/Payment";

// interfaces
import { IB2CPaymentGroup } from "@payment-ui/interfaces";

// test-ids
import { PAYMENT_GROUP_TEST_IDS } from "@swiggy-private/payment-test-ids";
import styles from "../PaymentGroup.v4.scss";

function BillToCompanyPaymentGroup(props: IB2CPaymentGroup): ReactElement | null {
    const paymentMethods = useMemo(() => getPaymentMethods(props), [props]);
    const isGroupEnabled = useMemo(() => isPaymentGroupEnabled(props.paymentData), [props.paymentData]);

    if (isEmpty(paymentMethods)) {
        return null;
    }

    return (
        <PaymentGroupContainer>
            {!props.hideGroupTitle && (
                <PaymentGroupTitle
                    title={getPaymentGroupDisplayName(props.paymentData)}
                    disableMessage={getPaymentGroupDisableMessage(props.paymentData)}
                    data-testid={PAYMENT_GROUP_TEST_IDS.TITLE.B2C}
                    groupIcon={getPaymentGroupIconUrl(props.paymentData)}
                />
            )}
            <div className={styles.paymentGroupContainer}>
                {paymentMethods.map((paymentMethod) => {
                    const id = generatePaymentMethodId(paymentMethod);
                    return (
                        <BillToCompanyPaymentMethod
                            id={id}
                            key={paymentMethod.name}
                            methodData={paymentMethod}
                            paymentActions={props.paymentActions}
                            paymentAmount={props.paymentAmount}
                            isPaymentGroupEnabled={isGroupEnabled}
                            selected={isPaymentMethodSelected(props.selectedPaymentId, id)}
                            expenseCodeData={props.expenseCodeData}
                            openBillImageWebview={props.openBillImageWebview}
                        />
                    );
                })}
            </div>
        </PaymentGroupContainer>
    );
}

export default memo(BillToCompanyPaymentGroup);
